<div class="title-element" [ngClass]="{ expanded: expanded, collapsed: !expanded }" (click)="toggleAccordion()">
    <span style="width: 100%">
        <span class="icon" *ngIf="icon">
            <i [style]="iconStyle"></i>
        </span>
        <span>
            {{ title }}
        </span>
    </span>

    <span
        class="edit-item"
        *ngIf="isEditable"
        hamIconShapes
        icon="assets/hamIcons/edit-outline.svg"
        [variant]="'white'"
        [size]="'xs'"
        [type]="'circle'"
        (click)="onEditClick()"
    ></span>

    <!-- Add toggle icon -->
    <span class="ham-icon">
        <i class="chevron-down-icon" [ngClass]="{ expanded: expanded, collapsed: !expanded }"></i>
    </span>
</div>

<div class="flex-container" *ngIf="expanded">
    <div class="button-wrapper" *ngIf="hasOtherYear || hasAddButton">
        <ham-tab-navigation
            *ngIf="hasOtherYear"
            [navigationItems]="navigationItems"
            [tabsTitles]="tabsTitles"
            [style]="'xs-pills'"
            (tabClick)="switchYear($event)"
        ></ham-tab-navigation>
        <ham-button
            *ngIf="hasAddButton"
            size="xs"
            outline="true"
            icon="assets/hamIcons/plus-outline.svg"
            (click)="onAddClick()"
            >{{ addButtonText }}</ham-button
        >
    </div>
    <ng-content *ngIf="isMainContentActive"></ng-content>
    <ng-content *ngIf="!isMainContentActive" select="[lastYear]"></ng-content>
</div>
